import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { BlankLayoutComponent } from './shared/components/layouts/blank-layout/blank-layout.component';
import { ReportLayoutComponent } from './shared/components/layouts/report-layout/report-layout.component';
import { AuthGuard } from './shared/guards/auth.guard';

export const rootRouterConfig: Routes =
  [
    {
      path: '',
      redirectTo: JSON.parse(localStorage.getItem("menu")) ? JSON.parse(localStorage.getItem("menu")).filter(x => x.Type == "link")[0]?.FullState : "home",
      pathMatch: 'full',
    },
    {
      path: '',
      component: AuthLayoutComponent,
      children: [
        {
          path: 'sessions',
          loadChildren: () =>
            import('./views/sessions/sessions.module').then(
              (m) => m.SessionsModule
            ),
          data: { title: 'Session' },
        },
      ],
    },
    {
      path: '',
      component: ReportLayoutComponent,
      canActivate: [AuthGuard],
      children: [

      ],
    },
    {
      path: '',
      component: BlankLayoutComponent,
      canActivate: [],
      children: [
        {
          path: 'report-semester-to-parent-print',
          loadChildren: () =>
            import('./views/report-semester-to-parent-print/report-semester-to-parent-print.module').then((m) => m.PrintReportSemesterToParentModule),
        },
      ],
    },
    {
      path: '',
      component: AdminLayoutComponent,
      canActivate: [AuthGuard],
      children: [
        {
          path: 'score-check-process-by-user',
          loadChildren: () =>
            import('./views/score-check-process-by-user/score-check-process-by-user.module').then((m) => m.ScoreCheckProcessByUserModule),
        },
        {
          path: 'score-check-process',
          loadChildren: () =>
            import('./views/score-check-process/score-check-process.module').then((m) => m.ScoreCheckProcessModule),
        },
        {
          path: 'score-check-process-monthly-comment',
          loadChildren: () =>
            import('./views/score-check-process-monthly-comment/score-check-process-monthly-comment.module').then((m) => m.ScoreCheckProcessMonthlyModule),
        },
        {
          path: 'score-sheet-lock',
          loadChildren: () =>
            import('./views/score-sheet-lock/score-sheet-lock.module').then((m) => m.ScoreSheetLockModule),
        },
        {
          path: 'monthly-comment-lock',
          loadChildren: () =>
            import('./views/monthly-comment-lock/monthly-comment-lock.module').then((m) => m.MonthlyCommentLockModule),
        },
        {
          path: 'final-score-compare',
          loadChildren: () =>
            import('./views/final-score-compare/final-score-compare.module').then((m) => m.FinalScoreCompareModule),
        },
        {
          path: 'final-score-export',
          loadChildren: () =>
            import('./views/final-score-export/final-score-export.module').then((m) => m.FinalScoreExportModule),
        },
        {
          path: 'avg-score-export',
          loadChildren: () =>
            import('./views/avg-score-export/avg-score-export.module').then((m) => m.AvgScoreExportModule),
        },
        {
          path: 'raw-score-export',
          loadChildren: () =>
            import('./views/raw-score-export/raw-score-export.module').then((m) => m.RawScoreExportModule),
        },
        {
          path: 'all-score-export',
          loadChildren: () =>
            import('./views/all-score-export/all-score-export.module').then((m) => m.AllScoreExportModule),
        },
        {
          path: 'class-permission',
          loadChildren: () =>
            import('./views/class-permission/class-permission.module').then((m) => m.ClassPermissionModule),
        },
        {
          path: 'report-statistic-by-school',
          loadChildren: () =>
            import('./views/report-statistic-by-school/report-statistic-by-school.module').then((m) => m.StatisticBySchoolModule),
        },
        {
          path: 'report-statistic-by-district',
          loadChildren: () =>
            import('./views/report-statistic-by-district/report-statistic-by-district.module').then((m) => m.StatisticByDistrictModule),
        },
        {
          path: 'report-semester-academic-report',
          loadChildren: () =>
            import('./views/report-semester-academic-report/report-semester-academic-report.module').then((m) => m.F005Module),
        },
        {
          path: 'report-semester-to-parent',
          loadChildren: () =>
            import('./views/report-semester-to-parent/report-semester-to-parent.module').then((m) => m.F004Module),
        },
        {
          path: 'report-final-score-history',
          loadChildren: () =>
            import('./views/report-final-score-history/report-final-score-history.module').then((m) => m.ReportFinalScoreHistoryModule),
        },
        {
          path: 'report-final-raw-score',
          loadChildren: () =>
            import('./views/report-final-raw-score/report-final-raw-score.module').then((m) => m.ReportFinalRawScoreModule),
        },
        {
          path: 'report-final-score-comparison',
          loadChildren: () =>
            import('./views/report-final-score-comparison/report-final-score-comparison.module').then((m) => m.ReportFinalScoreComparisonModule),
        },
        {
          path: 'report-semester-sheet',
          loadChildren: () =>
            import('./views/report-semester-to-parent-grid/report-semester-to-parent-grid.module').then((m) => m.F006Module),
        },
        {
          path: 'report-semester-to-school',
          loadChildren: () =>
            import('./views/report-semester-to-school/report-semester-to-school.module').then((m) => m.F003Module),
        },
        {
          path: 'report-monthly-to-parent',
          loadChildren: () =>
            import('./views/report-monthly-to-parent/report-monthly-to-parent.module').then((m) => m.F002Module),
        },
        {
          path: 'report-monthly-to-school',
          loadChildren: () =>
            import('./views/report-monthly-to-school/report-monthly-to-school.module').then((m) => m.F001Module),
        },
        {
          path: 'setup-recommendation-letter',
          loadChildren: () =>
            import('./views/setup-letter-recommendation/setup-letter-recommendation.module').then((m) => m.RecommendationLetterSetupModule),
        },
        {
          path: 'recommendation-letter',
          loadChildren: () =>
            import('./views/recommendation-letter/recommendation-letter.module').then((m) => m.RecommendationLetterModule),
        },
        {
          path: 'home',
          loadChildren: () =>
            import('./views/startv2/startv2.module').then((m) => m.StartV2Module),
          data: { title: 'Màn hình chính', breadcrumb: 'Start' },
        },
        {
          path: 'tinymce',
          loadChildren: () =>
            import('./views/tinymce/tinymce.module').then((m) => m.TinymceModule),
          data: { title: 'Html editor', breadcrumb: 'Test html editor' },
        },
        {
          path: 'group',
          loadChildren: () =>
            import('./views/groupv2/groupv2.module').then((m) => m.groupv2Module),
        },
        {
          path: 'user',
          loadChildren: () =>
            import('./views/userVe2/userVe2.module').then((m) => m.UserVe2Module),
        },
        {
          path: 'bieu-mau',
          loadChildren: () =>
            import('./views/file-template/file-template.module').then(
              (m) => m.FileTemplateModule
            ),
          data: { title: 'Quản lý biểu mẫu', breadcrumb: 'Biểu mẫu' },
        },
        {
          path: 'sample',
          loadChildren: () =>
            import('./views/sample/sample.module').then((m) => m.SampleModule),
          data: { title: 'Test', breadcrumb: 'Test' },
        },
        {
          path: 'profile',
          loadChildren: () =>
            import('./views/profile/profile.module').then((m) => m.ProfileModule),
          data: {
            title: 'Quản lý thông tin cá nhân',
            breadcrumb: 'Thông tin cá nhân',
          },
        },
        {
          path: 'dictionary',
          loadChildren: () =>
            import('./views/dictionaryv2/dictionaryv2.module').then(
              (m) => m.dictionaryv2Module
            ),
          data: {
            title: 'Danh mục loại từ điển',
            breadcrumb: 'dictionaryv2',
          },
        },
        {
          path: 'area',
          loadChildren: () =>
            import('./views/area/area.module').then(
              (m) => m.AreaModule
            ),
          data: {
            title: 'Area setup',
            breadcrumb: 'area',
          },
        },
        {
          path: 'school',
          loadChildren: () =>
            import('./views/school/school.module').then(
              (m) => m.SchoolModule
            ),
          data: {
            title: 'School setup',
            breadcrumb: 'school',
          },
        },
        {
          path: 'subject',
          loadChildren: () =>
            import('./views/subject/subject.module').then(
              (m) => m.SubjectModule
            ),
          data: {
            title: 'Subject setup',
            breadcrumb: 'subject',
          },
        },
        {
          path: 'academic-year',
          loadChildren: () =>
            import('./views/academic-year/academic-year.module').then(
              (m) => m.AcademicYearModule
            ),
          data: {
            title: 'Academic Year setup',
            breadcrumb: 'academic-year',
          },
        },
        {
          path: 'setup-rounded-score',
          loadChildren: () =>
            import('./views/setup-rounded-score/setup-rounded-score.module').then(
              (m) => m.SetupRoundedScoreModule
            ),
          data: {
            title: 'Rounded Score Setup',
            breadcrumb: 'setup-rounded-score',
          },
        },
        {
          path: 'setup-informal-score',
          loadChildren: () =>
            import('./views/setup-informal-score/setup-informal-score.module').then(
              (m) => m.SetupInformalScoreModule
            ),
          data: {
            title: 'Informal Score Setup',
            breadcrumb: 'setup-informal-score',
          },
        },
        {
          path: 'comment-template',
          loadChildren: () =>
            import('./views/comment-template/comment-template.module').then(
              (m) => m.CommentTemplateModule
            ),
          data: {
            title: 'Setup Comment Template',
            breadcrumb: 'comment-template',
          },
        },
        {
          path: 'back-paper',
          loadChildren: () =>
            import('./views/back-paper-template/back-paper-template.module').then(
              (m) => m.BackPaperModule
            ),
        },
        {
          path: 'comment-type-c1',
          loadChildren: () =>
            import('./views/comment-type-primary/comment-type-primary.module').then(
              (m) => m.CommentTypePrimaryModule
            ),
          data: {
            title: 'Setup Comment',
            breadcrumb: 'comment-type-primary',
          },
        }, {
          path: 'comment-type-c2',
          loadChildren: () =>
            import('./views/comment-type-primary/comment-type-primary.module').then(
              (m) => m.CommentTypePrimaryModule
            ),
          data: {
            title: 'Setup Comment',
            breadcrumb: 'comment-type-primary',
          },
        }, {
          path: 'comment-type-c3',
          loadChildren: () =>
            import('./views/comment-type-primary/comment-type-primary.module').then(
              (m) => m.CommentTypePrimaryModule
            ),
          data: {
            title: 'Setup Comment',
            breadcrumb: 'comment-type-primary',
          },
        },
        {
          path: 'setup-subject',
          loadChildren: () =>
            import('./views/setup-subject/setup-subject.module').then(
              (m) => m.ScoreSheetModule
            ),
          data: {
            title: 'Setup Subject',
            breadcrumb: 'setup-subject',
          },
        },
        {
          path: 'student',
          loadChildren: () =>
            import('./views/student/student.module').then(
              (m) => m.StudentModule
            ),
          data: {
            title: 'Student Manage',
            breadcrumb: 'student',
          },
        },
        {
          path: 'student-edit',
          loadChildren: () =>
            import('./views/student-edit/student-edit.module').then(
              (m) => m.StudentEditModule
            ),
          data: {
            title: 'Student Edit',
            breadcrumb: 'student-edit',
          },
        },
        {
          path: 'score-sheet',
          loadChildren: () =>
            import('./views/score-sheet/score-sheet.module').then(
              (m) => m.ScoreSheetModule
            ),
          data: {
            title: 'Score Sheet Manage',
            breadcrumb: 'score-sheet',
          },
        },
        {
          path: 'score-import',
          loadChildren: () =>
            import('./views/score-import/score-import.module').then(
              (m) => m.ScoreImportModule
            ),
          data: {
            title: 'Score import',
            breadcrumb: 'score-import',
          },
        },
        {
          path: 'score-check',
          loadChildren: () =>
            import('./views/score-check/score-check.module').then(
              (m) => m.ScoreCheckModule
            ),
          data: {
            title: 'Score check',
            breadcrumb: 'score-check',
          },
        },
        {
          path: 'score-detail',
          loadChildren: () =>
            import('./views/score-sheet-detail/score-sheet-detail.module').then(
              (m) => m.ScoreSheetDetailModule
            ),
          data: {
            title: 'Score Sheet Detail',
            breadcrumb: 'score-sheet-detail',
          },
        },
        {
          path: 'exam-type',
          loadChildren: () =>
            import('./views/exam-type/exam-type.module').then(
              (m) => m.ExamTypeModule
            ),
          data: { title: 'Exam Type', breadcrumb: 'exam-type' },
        },
        {
          path: 'structure-default-setup',
          loadChildren: () =>
            import('./views/score-sheet-default/score-sheet-default.module').then(
              (m) => m.ScoreSheetDefaultModule
            ),
          data: { title: 'Structure Default Setup', breadcrumb: 'structure-default-setup' },
        },
        {
          path: 'score-sheet-permission',
          loadChildren: () =>
            import('./views/score-sheet-permission/score-sheet-permission.module').then(
              (m) => m.ScoreSheetPermissionModule
            ),
          data: {
            title: 'Score Permission',
            breadcrumb: 'score-psermission',
          },
        },
        {
          path: 'rate-setup',
          loadChildren: () =>
            import('./views/setup-rating/setup-rating.module').then(
              (m) => m.SetupRatingModule
            ),
          data: {
            title: 'Rate Setup',
          },
        },
        {
          path: 'score-setup',
          loadChildren: () =>
            import('./views/setup-final-score/setup-final-score.module').then(
              (m) => m.SetupFinalScoreModule
            ),
          data: {
            title: 'Score Setup',
            breadcrumb: 'score-setup',
          },
        },
        {
          path: 'monthly-comment',
          loadChildren: () =>
            import('./views/monthly-comment/monthly-comment.module').then(
              (m) => m.MonthlyCommentModule
            ),
          data: {
            title: 'Monthly Comment',
            breadcrumb: 'monthly-comment',
          },
        },
        {
          path: 'monthly-comment-detail',
          loadChildren: () =>
            import('./views/monthly-comment-detail/monthly-comment-detail.module').then(
              (m) => m.MonthlyCommentDetailModule
            ),
          data: {
            title: 'Monthly Comment Detail',
            breadcrumb: 'monthly-comment-detail',
          },
        },
        {
          path: 'team',
          loadChildren: () =>
            import('./views/team/team.module').then((m) => m.teamModule),
          data: {
            title: 'Quản lý team',
            breadcrumb: 'Quản lý team',
          },
        },
      ],
    },
    {
      path: '**',
      redirectTo: 'sessions/404',
    },
  ];
